import { useReadContract } from "wagmi";
import { EXPECTED_CHAIN_ID } from "@/configs/expected-chain";
import { ELECTION_ABI } from "@/contract/abi/election";
import ContractAddress from "@/contract/addresses";

/**
 * Reads current election cycle from the Election contract.
 * Returns numeric cycle (bigint → number coercion).
 */
export function useCurrentCycle() {
  const { data, isLoading, isError, refetch } = useReadContract({
    address: ContractAddress.ELECTION,
    abi: ELECTION_ABI,
    chainId: EXPECTED_CHAIN_ID,
    functionName: "getCycle",
    query: { retry: false },
  });

  return {
    cycle: data !== undefined ? Number(data) : undefined,
    isLoading,
    isError,
    refetch,
  };
}
